import {
  CasMRTable,
  CasMRTCellRenderCurrrency,
  CasMRTCellRenderPercent,
  CasMRTCellRenderNumberWithCommas,
  CasMRTCellRenderDate,
  CasMRTCellRenderMonth,
} from 'src/compass/shared/components';
import { CommissionsTabProps } from '../PreliminaryCommissions';
import PreliminaryCommissionsTopToolbar from '../PreliminaryCommissionsTopToolbar';

export default function PreliminaryPayoutsCMETab({
  data,
  exportUrl,
  ...rest
}: CommissionsTabProps) {
  const columns = [
    {
      accessorKey: 'employee',
    },
    {
      accessorKey: 'date',
      header: 'Trade Month',
      Cell: CasMRTCellRenderMonth,
    },
    {
      accessorKey: 'officeSalesCode',
      header: 'Sales Code',
    },
    {
      accessorKey: 'accountShort',
      header: 'Account',
    },
    {
      accessorKey: 'accountCompany',
      header: 'Customer',
    },
    {
      accessorKey: 'accountOpened',
      header: 'Date Open',
      Cell: CasMRTCellRenderDate,
    },
    {
      accessorKey: 'total',
      header: 'Risk Mgt',
      Cell: CasMRTCellRenderCurrrency,
    },
    {
      accessorKey: 'tradeCount',
      header: '#Trades',
      Cell: CasMRTCellRenderNumberWithCommas,
    },
    {
      accessorKey: 'clearing',
      Cell: CasMRTCellRenderCurrrency,
    },
    {
      accessorKey: 'payoutRate',
      header: 'Payout',
      Cell: CasMRTCellRenderPercent,
    },
    {
      accessorKey: 'description',
    },
    {
      accessorKey: 'schedule',
    },
    {
      accessorKey: 'rate',
      header: 'Broker Rate',
    },
    {
      accessorKey: 'adjusted',
    },
    {
      accessorKey: 'commission',
      Cell: CasMRTCellRenderCurrrency,
    },
  ];

  return (
    <CasMRTable
      data={data?.result}
      columns={columns}
      renderTopToolbarCustomActions={() => (
        <PreliminaryCommissionsTopToolbar total={data?.total} exportUrl={exportUrl} />
      )}
      enableGrouping={false}
      enablePagination={false}
      {...rest}
    />
  );
}
